import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// const router = new VueRouter({
//   mode: 'history',

// })
export default new Router({
  scrollBehavior () {
    // 每次路由导航都滚动到页面顶部
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: 'home'
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        title: '首页'
      },
      component: () => import('@/views/home/index')
    },
    {
      path: '/intelligentEquipment',
      name: 'intelligentEquipment',
      component: () => import('@/views/productCenter/intelligentEquipment'),
      meta: {
        title: '智能设备'
      }
    },
    {
      path: '/lowAltitudeApp',
      name: 'lowAltitudeApp',
      component: () => import('@/views/productCenter/lowAltitudeApp'),
      meta: {
        title: '低空应用'
      }
    },
    {
      path: '/softwareSystem',
      name: 'softwareSystem',
      component: () => import('@/views/productCenter/softwareSystem/index'),
      meta: {
        title: '软件系统'
      }
    },
    {
      path: '/algorithmModel',
      name: 'algorithmModel',
      component: () => import('@/views/productCenter/algorithmModel'),
      meta: {
        title: '算法模型'
      }
    },

    {
      path: '/coreResearch',
      name: 'coreResearch',
      component: () => import('@/views/coreResearch/index'),
      meta: {
        title: '核心研究'
      }
    },

    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/about/index'),
      meta: {
        title: '关于觉加'
      }
    },

    {
      path: '/hgkacrjaqjjfa',
      name: 'hgkacrjaqjjfa',
      component: () => import('@/views/scheme/hgkacrjaqjjfa'),
      meta: {
        title: '海港口岸出入境安全解决方案'
      }
    },
    {
      path: '/jygyhlwsbsjdlhtzypfa',
      name: 'jygyhlwsbsjdlhtzypfa',
      component: () => import('@/views/scheme/jygyhlwsbsjdlhtzypfa'),
      meta: {
        title: '基于工业互联网设备数据的量化特征研判方案'
      }
    },
    {
      path: '/jyhlwgksjdlhtzypfa',
      name: 'jyhlwgksjdlhtzypfa',
      component: () => import('@/views/scheme/jyhlwgksjdlhtzypfa'),
      meta: {
        title: '基于互联网公开数据的量化特征研判方案'
      }
    },
    {
      path: '/kgkacrjaqjjfa',
      name: 'kgkacrjaqjjfa',
      component: () => import('@/views/scheme/kgkacrjaqjjfa'),
      meta: {
        title: '空港口岸出入境安全解决方案'
      }
    },
    {
      path: '/jyysjskjdsjypfa',
      name: 'jyysjskjdsjypfa',
      component: () => import('@/views/scheme/jyysjskjdsjypfa'),
      meta: {
        title: '基于隐私计算框架的数据研判方案'
      }
    },
    {
      path: '/ventureCapital',
      name: 'ventureCapital',
      component: () => import('@/views/ventureCapital/index'),
      meta: {
        title: '创业投资'
      }
    },
    {
      path: '*',
      redirect: 'home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js